<template>
	<div class="askpopup" v-if="askpopup.show">
		<div class="mask_bg"></div>
		<div class="popup">
			<h2>{{askpopup.title}}</h2>
			<div class="cont">
				<p class="tips">{{askpopup.tips}}</p>
			</div>
			<div class="btns">
				<div class="cancel" @click="hide">否</div>
				<div class="confirm" @click="confirm">是</div>
			</div>
		</div>
	</div>
</template>
<style>
	.mask_bg{z-index: 101;}
	.askpopup .popup {position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 102; width: 80%; background-color: #fff; border-radius: 10px;}
	.askpopup .popup h2{line-height: 20px; text-align: left; font-size: 15px; padding: 12px;}
	.askpopup .popup .cont{padding: 0px 12px 20px;}
	.askpopup .popup .tips{line-height: 20px; text-align: left; font-size: 13px;}
	.askpopup .popup .btns { display: flex; align-items: center; height: 44px; border-top:1px solid #e6e6e6;}
	.askpopup .popup .btns div {text-align: center; width: 100px;flex: 1;height: 100%;line-height: 44px; font-size: 18px;}
	.askpopup .popup .btns div.confirm{color: #328AFF;border-left: 1px solid #dedede;}
</style>

<script type="text/javascript">
	export default{
		props:['askpopup'],
		methods:{
			hide(){
				this.$emit('cancel')
			},
			confirm(){
				this.$emit('confirm')
			}

		}
	}
</script>


// WEBPACK FOOTER //
// src/common/askpopup.vue